import axiosConfig from "./axiosConfig";

// 202 kickoff response for the AI site-health investigation LRO. A fresh run
// carries `runId` + the `sessionId` its turn belongs to; a repeat POST while a
// run is already in flight returns `coalesced: true` (the new question was NOT
// started) and the caller simply polls the returned operationKey via
// /async_status.
export interface StartHealthInvestigationResponse {
  status: string;
  operationKey: string;
  siteId: string;
  runId?: string;
  sessionId?: string;
  coalesced?: boolean;
}

// `parentRunId` continues the session that run belongs to - the agent answers
// `focus` as a follow-up with the earlier turns in context. Omit it to start a
// fresh session.
const postSiteHealthInvestigate = async (
  authToken: string,
  siteId: string,
  focus?: string,
  parentRunId?: string
): Promise<StartHealthInvestigationResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/health/investigate`,
    {
      ...(focus ? { focus } : {}),
      ...(parentRunId ? { parentRunId } : {}),
    },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postSiteHealthInvestigate;
